var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TryCatchNode__container"},[_c('h4',[_vm._v("Try catch")]),_c('div',{staticClass:"TryCatchNode__input",attrs:{"label":_vm.tryText,"outlined":"","dense":"","hide-details":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }